import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MdOutlineDashboard } from 'react-icons/md';
import { MdOutlineBrowseGallery } from 'react-icons/md';
import { IoCreateOutline } from 'react-icons/io5';
import { MdOutlineGroups } from 'react-icons/md';

const SideNav = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 950);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isActive = (path) => location.pathname.includes(path);

  const navItems = [
    {
      path: '/dashboard',
      icon: <MdOutlineDashboard className="text-lg" />,
      label: 'Dashboard',
    },
    {
      path: '/browsegroups',
      icon: <MdOutlineBrowseGallery className="text-lg" />,
      label: 'Browse',
    },
    {
      path: '/creategroup',
      icon: <IoCreateOutline className="text-lg" />,
      label: 'Create Group',
    },
    {
      path: '/mygroups',
      icon: <MdOutlineGroups className="text-lg" />,
      label: 'My Groups',
    },
  ];

  const NavLink = ({ item }) => (
    <Link
      to={item.path}
      className={`
        flex items-center gap-2 px-3 py-2.5 my-2 rounded-lg transition-all duration-200 text-xs
        ${
          isActive(item.path)
            ? 'bg-gradient-to-r from-[#6dc12b] to-[#5ba424] text-white shadow-sm'
            : 'text-gray-600 hover:bg-[#6dc12b]/10 hover:text-[#6dc12b]' // Updated hover styles
        }
        ${isMobile ? 'justify-center' : 'mx-2'}
      `}
    >
      {item.icon}
      {!isMobile && (
        <span className="font-medium whitespace-nowrap">{item.label}</span>
      )}
    </Link>
  );

  if (isMobile) {
    return (
      <div className="fixed bottom-0 w-full bg-[#f7fbee] border-t border-gray-200 shadow-lg z-50">
        <div className="flex justify-around items-center px-4 py-2">
          {navItems.map((item) => (
            <NavLink key={item.path} item={item} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f7fbee] border-r border-gray-100 shadow-sm">
      <div className="sticky top-0 p-3">
        <nav className="space-y-2">
          {navItems.map((item) => (
            <NavLink key={item.path} item={item} />
          ))}
        </nav>
      </div>
    </div>
  );
};

export default SideNav;
